import {
    apiRequest,
    mappingKelasPegawaiList,
    mappingKelasPegawaiActive,
    mappingKelasPegawaiInactive,
} from "../../../../../services/adapters/kepegawaian/mappingKelasPegawaiService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", mappingKelasPegawaiList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", mappingKelasPegawaiInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", mappingKelasPegawaiActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository